function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "black",
  fillOpacity: 0.75
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5999 5.30349C10.9129 4.77988 11.5511 4.53876 12.1369 4.73402C12.7238 4.92964 13.09 5.50731 13.0245 6.11526L13.0221 6.13175V17.8678L13.0245 17.8847C13.0872 18.4662 12.7548 19.02 12.2122 19.2383L12.1369 19.266C11.5511 19.4612 10.9129 19.2201 10.5999 18.6965L10.5937 18.6854L7.85628 15.1663L6.47781 15.1667C5.68978 15.1667 5.04581 14.5499 5.00234 13.7728L5 13.6889V10.3111C5 9.52304 5.61679 8.87907 6.39395 8.8356L6.47781 8.83326H7.85628L10.5937 5.31416L10.5999 5.30349Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5877 17.2926C20.68 14.2841 20.68 10.2406 18.5877 7.2297C18.4049 6.96671 18.0455 6.90116 17.7833 7.08394C17.5203 7.26672 17.4555 7.62688 17.6383 7.8891C19.4839 10.5467 19.4839 13.9779 17.6383 16.6309C17.4555 16.8939 17.5203 17.2541 17.7825 17.4361C17.8836 17.5063 17.9985 17.5402 18.1126 17.5402C18.2954 17.5402 18.4751 17.4538 18.5877 17.2926Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6843 15.3915C17.791 13.4634 17.791 11.0649 16.6843 9.13069C16.5255 8.85382 16.173 8.7605 15.8954 8.91629C15.6185 9.07516 15.5221 9.42838 15.681 9.70603C16.5841 11.2847 16.5841 13.2421 15.681 14.8162C15.5221 15.0923 15.6177 15.4463 15.8946 15.6051C15.9856 15.6576 16.0843 15.6822 16.1823 15.6822C16.3828 15.6822 16.5771 15.5781 16.6843 15.3915Z",
  fill: "white"
});

var SvgIconVolumnOn = function SvgIconVolumnOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVolumnOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_volumn_on.4cda4586.svg";
export { ForwardRef as ReactComponent };